import { cn } from '../../lib/utils';

export interface StatusChevronStep {
  key: string;
  label: string;
}

export function StatusChevron({
  steps,
  currentKey,
}: {
  steps: readonly StatusChevronStep[];
  currentKey: string;
}) {
  const currentIdx = steps.findIndex((s) => s.key === currentKey);

  return (
    <div className="flex w-full">
      {steps.map((step, i) => {
        const reached = currentIdx !== -1 && i <= currentIdx;
        const isFirst = i === 0;
        const isLast = i === steps.length - 1;
        return (
          <div
            key={step.key}
            className={cn(
              'flex h-10 flex-1 items-center justify-center whitespace-nowrap px-5 text-xs font-semibold transition-colors',
              reached ? 'bg-success-600 text-white' : 'bg-gray-200 text-gray-500',
            )}
            style={{
              clipPath: isFirst
                ? 'polygon(0 0, calc(100% - 14px) 0, 100% 50%, calc(100% - 14px) 100%, 0 100%)'
                : isLast
                  ? 'polygon(0 0, 100% 0, 100% 100%, 0 100%, 14px 50%)'
                  : 'polygon(0 0, calc(100% - 14px) 0, 100% 50%, calc(100% - 14px) 100%, 0 100%, 14px 50%)',
              marginLeft: isFirst ? 0 : -12,
              zIndex: steps.length - i,
            }}
          >
            {step.label}
          </div>
        );
      })}
    </div>
  );
}
